module.exports = __webpack_public_path__ + "img/renegades3.91bdc24.jpg";